import { render, staticRenderFns } from "./OpenTokenList.vue?vue&type=template&id=61c0855a&scoped=true"
import script from "./OpenTokenList.vue?vue&type=script&lang=js"
export * from "./OpenTokenList.vue?vue&type=script&lang=js"
import style0 from "./OpenTokenList.vue?vue&type=style&index=0&id=61c0855a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0855a",
  null
  
)

export default component.exports